module.exports = __webpack_public_path__ + "images/bg-coupon-n.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/bg-coupon-n.png
// module id = 833
// module chunks = 124